'use client'

import {
  GetProductsByCategoryPathQuery,
  GetProductsByCategoryPathQueryVariables,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import React from 'react'
import { GET_PRODUCTS_BY_CATEGORY_PATH } from '@dustin-web/microsite-data/src/graphql/product/get-products-by-category-path.graphql'
import { FacetParameterInput } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { ProductCardGallery } from '../cards'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'
import { DigitalDataOrigin } from '../utils/digital-data-types'
import { getSortBy } from '../product-list/get-sort-by'

type Props = {
  categoryPath: string
  numberOfProducts: number
  activeFilters: FacetParameterInput[]
  digitalDataOrigin: DigitalDataOrigin
  searchPhrase: string
  sortBy: string
}

export const ProductListByCategoryPath = ({
  categoryPath,
  numberOfProducts,
  activeFilters,
  digitalDataOrigin,
  searchPhrase,
  sortBy,
}: Props) => {
  const { data } = useGraphql<
    GetProductsByCategoryPathQuery,
    GetProductsByCategoryPathQueryVariables
  >(GET_PRODUCTS_BY_CATEGORY_PATH, {
    variables: {
      categoryPath: categoryPath,
      numberOfProducts,
      selectedFacets: activeFilters,
      searchPhrase: searchPhrase,
      sortBy: getSortBy(sortBy),
    },
  })

  const productReferences = data?.productSearchByCategoryPath?.productReferences?.slice(
    0,
    numberOfProducts
  )
  if (!productReferences) {
    return null
  }

  return (
    <div className="row sm-gutters">
      {productReferences.map(
        (productReference, i) =>
          productReference.searchResultProduct && (
            <ProductCardGallery
              key={i}
              ticket={productReference.ticket}
              product={productReference.searchResultProduct}
              sizeClasses="col-12 col-sm-6 col-md-4 col-lg-3"
              imagePriority={i < 4}
              digitalDataOrigin={digitalDataOrigin}
              digitalIndex={i}
            />
          )
      )}
    </div>
  )
}
